/**
 * Input Component — Yoluno design system
 *
 * var(--radius-md) corners, 1px border-default, brand border on focus,
 * focus-ring box-shadow.
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          [
            'flex h-12 w-full',
            'rounded-[var(--radius-md)]',
            'border border-[var(--border-default)]',
            'bg-[var(--surface-card)]',
            'px-4 py-3',
            'font-body text-body-sm text-[var(--text-body)]',
            'shadow-[var(--shadow-xs)]',
            'transition-[border-color,box-shadow] duration-[var(--dur-base)] [transition-timing-function:var(--ease-out)]',
            'placeholder:text-[var(--text-soft)]',
            'file:border-0 file:bg-transparent file:text-body-sm file:font-medium',
            'focus-visible:outline-none focus-visible:border-[var(--border-brand)] focus-visible:shadow-[var(--focus-ring)]',
            'disabled:cursor-not-allowed disabled:opacity-50',
          ].join(' '),
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
